"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CERTIFICATION_DISPLAY_NAMES = void 0;
exports.CERTIFICATION_DISPLAY_NAMES = {
    AACRN: 'AACRN',
    ACCNS_AG: 'ACCNS-AG',
    ACCNS_N: 'ACCNS-N',
    ACCNS_P: 'ACCNS-P',
    ACHPN: 'ACHPN',
    ACLS: 'ACLS',
    ACNPC: 'ACNPC',
    ACNPC_AG: 'ACNPC-AG',
    ACNP_BC: 'ACNP-BC',
    ACNS_BC: 'ACNS-BC',
    ACRN: 'ACRN',
    ADM_BC: 'ADM-BC',
    AE_C: 'AE-C',
    AFN_BC: 'AFN-BC',
    AGACNP_BC: 'AGACNP-BC',
    AGCNS_BC: 'AGCNS-BC',
    AGN_BC: 'AGN-BC',
    AGPCNP_BC: 'AGPCNP-BC',
    AHN_BC: 'AHN-BC',
    ANP_BC: 'ANP-BC',
    AOCN: 'AOCN',
    AOCNP: 'AOCNP',
    AOCNS: 'AOCNS',
    APHN_BC: 'APHN-BC',
    APLS: 'APLS',
    A_GNP: 'A-GNP',
    BC_ADM: 'BC-ADM',
    BLS: 'BLS',
    BMTCN: 'BMTCN',
    CALS: 'CALS',
    CANS: 'CANS',
    CAPA: 'CAPA',
    CARN: 'CARN',
    CARN_AP: 'CARN-AP',
    CBCN: 'CBCN',
    CBHC: 'CBHC',
    CCCN: 'CCCN',
    CCCN_AP: 'CCCN-AP',
    CCHP_A: 'CCHP-A',
    CCHP_RN: 'CCHP-RN',
    CCHT: 'CCHT',
    CCHTA: 'CCHTA',
    CCNS: 'CCNS',
    CCRA: 'CCRA',
    CCRC: 'CCRC',
    CCRN: 'CCRN',
    CCRN_E: 'CCRN-E',
    CCRN_K: 'CCRN-K',
    CCRP: 'CCRP',
    CCTM: 'CCTM',
    CDE: 'CDE',
    CDN: 'CDN',
    CD_LPN: 'CD-LPN',
    CD_LVN: 'CD-LVN',
    CEN: 'CEN',
    CENP: 'CENP',
    CFCN: 'CFCN',
    CFRN: 'CFRN',
    CGRN: 'CGRN',
    CHFN: 'CHFN',
    CHFN_K: 'CHFN-K',
    CHPCA: 'CHPCA',
    CHPLN: 'CHPLN',
    CHPN: 'CHPN',
    CHPNA: 'CHPNA',
    CHPPN: 'CHPPN',
    CHSA: 'CHSA',
    CIC: 'CIC',
    CM: 'CM',
    CMC: 'CMC',
    CMCN: 'CMCN',
    CMSRN: 'CMSRN',
    CNE: 'CNE',
    CNL: 'CNL',
    CNML: 'CNML',
    CNN: 'CNN',
    CNN_M: 'CNN/M',
    CNN_NP: 'CNN-NP',
    CNOR: 'CNOR',
    CNRN: 'CNRN',
    CNS_BC: 'CNS-BC',
    CNS_CP: 'CNS-CP',
    COCN: 'COCN',
    COCN_AP: 'COCN-AP',
    COHN: 'COHN',
    COHN_S: 'COHN-S',
    CORLN: 'CORLN',
    CPAN: 'CPAN',
    CPEN: 'CPEN',
    CPHON: 'CPHON',
    CPHQ: 'CPHQ',
    CPHRM: 'CPHRM',
    CPLC: 'CPLC',
    CPN: 'CPN',
    CPNP_PC: 'CPNP-PC',
    CPON: 'CPON',
    CPP_AC: 'CPP-AC',
    CPSN: 'CPSN',
    CRN: 'CRN',
    CRNA: 'CRNA',
    CRNFA: 'CRNFA',
    CRNI: 'CRNI',
    CRNO: 'CRNO',
    CRRN: 'CRRN',
    CSC: 'CSC',
    CTRN: 'CTRN',
    CUA: 'CUA',
    CUNP: 'CUNP',
    CURN: 'CURN',
    CWCN: 'CWCN',
    CWCN_AP: 'CWCN-AP',
    CWOCN: 'CWOCN',
    CWOCN_AP: 'CWOCN-AP',
    CWON: 'CWON',
    CWON_AP: 'CWON-AP',
    C_EFM: 'C-EFM',
    C_NPT: 'C-NPT',
    DCNP: 'DCNP',
    DNC: 'DNC',
    ENPC: 'ENPC',
    ENP_BC: 'ENP-BC',
    FNP_BC: 'FNP-BC',
    FNP_C: 'FNP-C',
    GCNS_BC: 'GCNS-BC',
    GNP_BC: 'GNP-BC',
    HHCNS_BC: 'HHCNS-BC',
    HNB_BC: 'HNB-BC',
    HN_BC: 'HN-BC',
    HWNC_BC: 'HWNC-BC',
    LNCC: 'LNCC',
    NCSN: 'NCSN',
    NC_BC: 'NC-BC',
    NEA_BC: 'NEA-BC',
    NE_BC: 'NE-BC',
    NNP_BC: 'NNP-BC',
    NP_C: 'NP-C',
    NRP: 'NRP',
    OCN: 'OCN',
    OCNS_C: 'OCNS-C',
    ONC: 'ONC',
    ONP_C: 'ONP-C',
    PALS: 'PALS',
    PCCN: 'PCCN',
    PCCN_K: 'PCCN-K',
    PCNS_BC: 'PCNS-BC',
    PHCNS_BC: 'PHCNS-BC',
    PHMS: 'PHMS',
    PHNA_BC: 'PHNA-BC',
    PMHCNS_BC: 'PMHCNS-BC',
    PMHNP_BC: 'PMHNP-BC',
    PPCNP_BC: 'PPCNP-BC',
    RNC_LRN: 'RNC-LRN',
    RNC_MNN: 'RNC-MNN',
    RNC_NIC: 'RNC-NIC',
    RNC_OB: 'RNC-OB',
    RN_BC: 'RN-BC',
    SANE_A: 'SANE-A',
    SANE_P: 'SANE-P',
    SCRN: 'SCRN',
    SNP_BC: 'SNP-BC',
    STABLE: 'STABLE',
    TCRN: 'TCRN',
    TNCC: 'TNCC',
    WHNP_BC: 'WHNP-BC',
    OTHER: 'Other',
};
//# sourceMappingURL=certification-display-labels.js.map